import CheckboxFieldElement from "./checkbox-field-element";
import DOMElement from "../../../dom-element";

export default class LmsCheckboxFieldElement extends CheckboxFieldElement {
    constructor(props) {
        super(props);
    }

    _setProps() {
        super._setProps();

        this.class = DOMElement.classListFrom(this.class, 'f-lms-checkbox-field');
        this.theme = 'lms';
    }
}